// extracted by mini-css-extract-plugin
export default {"block":"skills_block__tJlO4","box":"skills_box__OrAF+","subtitle":"skills_subtitle__+YKtP","details":"skills_details__qFf8T","list":"skills_list__KQqGu"};